import moment from 'moment';

const currentYear = (new Date()).getFullYear();
const currentMonth = (new Date()).getMonth(); // (January gives 0)
// adding 1 to current month to account for zero based month value
const thisMonth = moment.duration((currentMonth + 1), 'month');
const startMonth = moment.duration(1, 'month');
const passedMonths = thisMonth.subtract(startMonth).months();

// params: [startYear: number]
const getDateDropDownOptionsMonthAndYear = (startYear) => {
  const months = [...Array(12).keys()]
    .map((key) => ({
      name: new Date(0, key).toLocaleString('en', { month: 'long' }),
      value: (key + 1),
    }));

  const dateOptions = [];

  for (let year = startYear; year <= currentYear; year += 1) {
    if (year === currentYear) {
      dateOptions.push(
        months.slice(0, passedMonths + 1).map((month) => ({
          name: `${month.name} ${year}`,
          value: `${month.value}-${year}`,
        })),
      );
    } else {
      // For all other years, include all 12 months
      dateOptions.push(
        months.map((month) => ({
          name: `${month.name} ${year}`,
          value: `${month.value}-${year}`,
        })),
      );
    }
  }

  // Flatten the array of date options
  return [...dateOptions.flat()];
};

const getFinancialQuarterForMonthIndex = (monthIndex) => {
  const numericalMonth = monthIndex + 1;
  // Q1
  if (numericalMonth >= 1 && numericalMonth <= 3) {
    return 1;
  }
  // Q2
  if (numericalMonth >= 4 && numericalMonth <= 6) {
    return 2;
  }
  // Q3
  if (numericalMonth >= 7 && numericalMonth <= 9) {
    return 3;
  }
  // Q4
  if (numericalMonth >= 10 && numericalMonth <= 12) {
    return 4;
  }
  return 0;
};

const getQuarterStartAndEndTimestamps = (timestamp) => ({
  start: moment.unix(timestamp).startOf('quarter').unix(),
  end: moment.unix(timestamp).endOf('quarter').unix(),
});

const getDateDropDownOptionsFinancialQuarters = (numQuarters) => {
  const dateOptions = [];
  for (let i = 0; i < numQuarters; i += 1) {
    const quarter = moment().subtract(i, 'Q');
    dateOptions.push({
      name: `${quarter.format('YYYY')} Q${quarter.quarter()}`,
      value: quarter.unix(),
      id: quarter.unix(),
    });
  }

  return dateOptions;
};

const getQuarterRange = (quarter, year) => {
  const start = moment(year, 'YYYY').quarter(quarter).startOf('quarter').unix();
  const end = moment(year, 'YYYY').quarter(quarter).endOf('quarter').unix();
  return { start, end };
};

export {
  currentYear,
  currentMonth,
  getFinancialQuarterForMonthIndex,
  getDateDropDownOptionsMonthAndYear,
  getDateDropDownOptionsFinancialQuarters,
  getQuarterRange,
  getQuarterStartAndEndTimestamps,
};
